export default "__VITE_ASSET__BwVgDQXv__";